import Vue from 'vue';
import Vuex from 'vuex';
import XLSX from 'xlsx';


Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    key: 0,
    ready: false,
    campaign: 'AZimport.xlsx',
    campaignSelected: 'Campaña 1',
    campaignList:['Campaña 1', 'Campaña 2', 'Campaña 3', 'Campaña 4', 'Campaña 5'],
    workbook: {},
    data: [],
    headers: [],
    regions: [],
    crops: [],
    cropsRegions: [],
    coords: [],
    prices: [],
    supplies:[],
    grains:[],
    info:[],
    adv:[]
  },
  mutations: {
    set_workbook(state, workbook){
      state.workbook = workbook;
      state.data = XLSX.utils.sheet_to_json(state.workbook.Sheets.DATA, {header:1});
      state.prices = XLSX.utils.sheet_to_json(state.workbook.Sheets.PRECIOS, {header:1});
      state.info = XLSX.utils.sheet_to_json(state.workbook.Sheets.INFO, {header:1});
      let adv = XLSX.utils.sheet_to_json(state.workbook.Sheets.PUBLICIDAD, {header:1});
      let coords = XLSX.utils.sheet_to_json(state.workbook.Sheets.COORD, {header:1});
      state.info = state.info[1];
      state.adv = {};
      state.adv.logo = adv[1];
      state.adv.url = adv[2];
      state.headers = state.data[0];
      coords.map((item) => {
        state.coords[item[0]] = [item[1],item[2]];
      });
    },
    load_regions(state) {
      let result = [];
      state.data.map((item, index) => {
        if (result.indexOf(item[0]) === -1 && index !== 0)
          result.push(item[0]);
      });
      state.regions = result;
    },
    load_crops(state) {
      let result = [];
      state.data.map((item, index) => {
        if (result.indexOf(item[1]) === -1 && index !== 0)
          result.push(item[1]);
      });
      state.crops = result;
      state.cropsRegions = result.slice(0,4);
    },
    load_grains(state) {
      let result = [];
      state.prices.map((item, index) => {

        if (result.indexOf(item[1]) == -1 && index != 0 && item[0] == 'Granos')
          result.push(item[1]);
      });
      state.grains = result;
    },
    load_supplies(state) {
      let result = [];
      state.prices.map((item, index) => {
        if (result.indexOf(item[1]) == -1 && index != 0 && item[0] == 'Insumos')
          result.push(item[1]);
      });
      state.supplies = result;
    },
    change_campaign_selected(state, number) {
      state.campaignSelected = state.campaignList[number-1];
    },
    change_campaign(state, number) {
      state.ready = false;
      switch (number) {
      case 1: state.campaign = 'AZimport.xlsx'; break;
      case 2: state.campaign = 'AZimport1.xlsx'; break;
      case 3: state.campaign = 'AZimport2.xlsx'; break;
      case 4: state.campaign = 'AZimport3.xlsx'; break;
      case 5: state.campaign = 'AZimport4.xlsx'; break;
      }
      state.key++;
    },

    load_campaign(state, {index, filename}) {
      const url = "https://www.agbi.com.ar/uploads/" + filename + "?t=" + Math.random();
      let req = new XMLHttpRequest();
      req.open("GET", url, true);
      req.responseType = "arraybuffer";

      req.onload = function () {
        let data = new Uint8Array(req.response);
        let workbook = XLSX.read(data, {type: "array", cellDates: false, cellText: true});
        const config = XLSX.utils.sheet_to_json(workbook.Sheets.CONFIGURACION, {header:1});
        if (config.length > 0) {
          Vue.set(state.campaignList, index, config[1][0]);
        }
        state.campaignSelected = state.campaignList[0];

      }.bind(this);

      req.onerror = function (error) {
        console.log(error);
      };

      req.send();
    }

  },
  actions: {
    getWorkbook({state, commit}) {
      const url = "https://www.agbi.com.ar/uploads/" + state.campaign + "?t=" + Math.random();
      let req = new XMLHttpRequest();
      req.open("GET", url, true);
      req.responseType = "arraybuffer";

      req.onload = function () {
        let data = new Uint8Array(req.response);
        let workbook = XLSX.read(data, {type: "array", cellDates: false, cellText: true});

        commit('set_workbook', workbook);
        commit('load_crops');
        commit('load_regions');
        commit('load_grains');
        commit('load_supplies');
        state.ready = true;

      }.bind(this);

      req.onerror = function (error) {
        console.log(error);
      };

      req.send();
    },

    setWorkbook({commit}, workbook) {
      commit('set_workbook', workbook);
      commit('load_crops');
      commit('load_regions');
      commit('load_grains');
      commit('load_supplies');
      commit('load_campaigns');
    },

    loadCampaigns({commit}) {
      commit('load_campaign', {index: 0, filename: 'AZimport.xlsx'});
      commit('load_campaign', {index: 1, filename: 'AZimport1.xlsx'});
      commit('load_campaign', {index: 2, filename: 'AZimport2.xlsx'});
      commit('load_campaign', {index: 3, filename: 'AZimport3.xlsx'});
      commit('load_campaign', {index: 4, filename: 'AZimport4.xlsx'});
    },

    getDataRow({state}, payload) {
      let response = [];
      for (let key in state.data)
        if (state.data[key][0] == payload.regionSelected && state.data[key][1] == payload.cropSelected) {
          let row = state.data[key];

          for (let index in row) {
            response[state.headers[index]] = row[index];
          }
        }
      return response;
    },

    changeCampaign({commit, dispatch}, number) {
      commit('change_campaign_selected', number);
      commit('change_campaign', number);
      dispatch('getWorkbook');

    },
  }

});

export default store;
